import Api from "../../Api";
import { modifyError } from "../../Validation/ModifyErrros";

export function getUserDetails() {
  try {
    const userDetails = localStorage.getItem("userDetails");
    return userDetails ? JSON.parse(userDetails) : null;
  } catch {
    return null;
  }
}



export const addlog = async (actions, type, data, user_id) => {
 const resolvedUserId = user_id || getUserDetails()?.id;
  let payloaddata = {
    actions,
    type,
    data: JSON.stringify(data),
    user_id: resolvedUserId,
  };
  try {
    let res = await Api.post("/log", payloaddata);
    return res?.data;
  } catch (e) {
    console.log(e);
    let error = modifyError(e);
    return { error: error.message };
  }
};

export const addBulkLogs = async (logEntries) => {
  try {
    // Run all API calls in parallel
    const promises = logEntries.map(async (entry) => {
      try {
        return await addlog(entry.actions, entry.type, entry.data, entry.user_id);
      } catch (error) {
        return { error: error.message, entry };
      }
    });
    
    const results = await Promise.allSettled(promises);
    
    // Process results
    const successful = [];
    const failed = [];
    
    results.forEach((result, index) => {
      if (result.status === 'fulfilled' && !result.value.error) {
        successful.push(result.value);
      } else {
        failed.push({
          entry: logEntries[index],
          error: result.value?.error || result.reason
        });
      }
    });
    
    return {
      successful: successful.length,
      failed: failed.length,
      errors: failed,
      total: logEntries.length
    };
  } catch (e) {
    return { error: "Bulk logging failed", details: e.message };
  }
};
export const addAPIlog = async (data) => {
  try {
    let res = await Api.post("/log/api-route", data);
    return res?.data;
  } catch (e) {
    console.log(e);
    let error = modifyError(e);
    return { error: error.message };
  }
};

export const getlogData = async (query) => {
  try {
    let res = await Api.get("/log", {
      params: query,
    });

    return res?.data || [];
  } catch (e) {
    return { error: "Something Wrong" };
  }
};
export const getloylteelogData = async (query) => {
  try {
    let res = await Api.get("/loyltee-tracking", {
      params: query,
    });

    return res?.data || [];
  } catch (e) {
    return { error: "Something Wrong" };
  }
};
export const getoldData = async (query) => {
  try {
    let res = await Api.get("/log/old-log", {
      params: query,
    });

    return res?.data || [];
  } catch (e) {
    return { error: "Something Wrong" };
  }
};
export const getUserlogData = async (query) => {
  try {
    let res = await Api.get("/log/user-tracking", {
      params: query,
    });

    return res?.data || [];
  } catch (e) {
    return { error: "Something Wrong" };
  }
};
export const updateUserAPIlogData = async (id, data) => {
  try {
    let res = await Api.patch("/log/api-route/" + id, data);

    return res?.data || [];
  } catch (e) {
    return { error: "Failed to Update" };
  }
};

export const getUserAPIlogData = async (query) => {
  try {
    let res = await Api.get("/log/api-route", {
      params: query,
    });

    return res?.data || [];
  } catch (e) {
    return { error: "Something Wrong" };
  }
};

export const deletelogData = async (id) => {
  try {
    let res = await Api.delete("/log/" + id);

    return res?.data || [];
  } catch (e) {
    return { error: "Failed to delete" };
  }
};
export const deleteApilogData = async (id) => {
  try {
    let res = await Api.delete("/log/api-log/" + id);

    return res?.data || [];
  } catch (e) {
    return { error: "Failed to delete" };
  }
};

export const updatelogData = async (id, data) => {
  try {
    let res = await Api.patch("/log/" + id, data);

    return res?.data || [];
  } catch (e) {
    let error = modifyError(e);
    return { error: error.message };
  }
};
